import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ReactTableForm from "../../../components/Common/ReactTableForm";
import { Link } from "react-router-dom";
import classNames from "classnames";

const NotificationsTable = ({ data, isLoading, onTableChange }) => {

  /*
  * @param status: true | false | null
  * */
  const getNotificationStatusAccessor = (status) => (
    <span className="avatar-title bg-transparent text-reset">
      <div className={classNames(`notification-item-status`, {
        'bg-success': status === true,
        'bg-danger': status === false,
        // 'bg-dark': status === null
      })}>
        {(status === true)
          ? <i className="mdi mdi-check" />
          : status === false ? <i className="mdi mdi-close" />
            : status === null ? "—"
              : null
        }
      </div>
    </span>
  );

  const [columns, setColumns] = React.useState([
    {
      Header: "ID",
      src: "id",
      style: {
        textAlign: 'center',
        minWidth: 110,
      },
      accessor: row => <Link to={`/offers/${row.id}?history=true`}>{row.id}</Link>
      // isSorted: true,
    },
    {
      Header: "Offer name",
      src: "name",
      style: {
        textAlign: 'center',
        minWidth: 110,
      },
      // style: {
      //   ...this.styleNumbers,
      //   minWidth: 110,
      // },
      accessor: row => <Link to={`/offers/${row.id}?history=true`}>{row.name}</Link>
      // isSorted: true,
    },
    {
      Header: "Date from",
      src: "date_from",
      style: {
        textAlign: 'center',
        minWidth: 110,
      },
      // style: {
      //   ...this.styleNumbers,
      //   minWidth: 110,
      // },
      accessor: row => row.date_from
      // isSorted: true,
    },
    {
      Header: "Offer without",
      // src: "offer_without",
      // style: {
      //   ...this.styleNumbers,
      //   minWidth: 110,
      // },
      columns: [
        {
          Header: "Platform",
          // accessor: () => 'test',
          accessor: (row) => getNotificationStatusAccessor(row.exist_platform_data)
        },
        {
          Header: "Tracker",
          accessor: (row) => getNotificationStatusAccessor(row.exist_without_trackers_data)
        },
        {
          Header: "Tracker cohort",
          accessor: (row) => getNotificationStatusAccessor(row.exist_without_trackers_cohort_data)
        },
        {
          Header: "Tracker event",
          accessor: (row) => getNotificationStatusAccessor(row.exist_without_trackers_events_data)
        }
      ]
      // accessor: row => row.name,
    }
  ]);

  return (
    <NotificationsTableStyled>
      <ReactTableForm
        loading={isLoading}
        columns={columns}
        data={data}
        onTableChange={onTableChange}
        // firstIsSticky
      />
    </NotificationsTableStyled>
  );
};

NotificationsTable.propTypes = {
  data: PropTypes.any,
  isLoading: PropTypes.bool,
  onTableChange: PropTypes.func
};

const NotificationsTableStyled = styled.div`

  .notification-item-status {
    width: 20px;
    height: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    
    i {
      color: #fff;
    }
  }
`;

export default NotificationsTable;